// Construit et déclenche le téléchargement d'un CSV depuis des données déjà
// chargées côté client — inutile de repasser par le serveur, la fiche est en
// mémoire.
//
// Séparateur ';' et BOM UTF-8 : mêmes conventions que les exports serveur de
// l'application (server/utils/csvExport.js), pour qu'Excel en français ouvre le
// fichier directement au lieu de tout empiler dans la première colonne.
// Construit depuis son point de code : ni caractère invisible dans le source,
// ni séquence d'échappement qu'un outil de réencodage pourrait abîmer.
const BOM = String.fromCharCode(0xfeff);

export function downloadCsv(filename, headers, rows) {
    const escape = (value) => {
        const text = value === null || value === undefined ? '' : String(value);
        return `"${text.replace(/"/g, '""')}"`;
    };

    const csv = BOM + [headers, ...rows]
        .map((row) => row.map(escape).join(';'))
        .join('\r\n');

    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

// Nombre décimal au format français : Excel en français attend la virgule.
// Écrit tel quel, un score EPSS de 0.2923 arriverait en texte, donc ni triable
// ni sommable dans le tableur.
export function csvNumber(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace('.', ',');
}
